import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["output","list", "item"];

  sortableConfig ={
    animation: 150,
    onEnd: () => this.updatePositions(),
  }

  connect() {
    this.sortable = Sortable.create(this.listTarget, this.sortableConfig);
    // Initial update of positions
    console.log("SortableJS controller connected!");
    this.updatePositions();
  }

  updatePositions() {
    this.itemTargets.forEach((el, index) => {
      el.querySelector(".position-label").textContent = index + 1;
    });
    this.outputTarget.value = JSON.stringify(
      this.itemTargets.map(el => el.dataset.id)
    );
  }
}